<div class="error-container">
  <span class="width-90">{{data.errorMsg}}</span>
  <span>
    <button mat-button (click)="snackBarRef.dismissWithAction()" [ariaLabel]="data.ariaLabel" class="action-button">
      <span aria-hidden="true">{{data.action}}</span>
    </button>
    <span class="sr-only">{{data.ariaLabel}}</span>
  </span>
</div>

